import { LockedFeatureDisplayConfig } from './types';
import { FC, JSX } from 'react';
import { DisabledDisplayOptions } from '../../SystemSettings/hooks/lockedFeatures/types';
import LockedFeatureTooltip from './LockedFeatureTooltip';
import LockedFeatureShowstopper from './LockedFeatureShowstopper';

interface FeatureLockProps {
    displayOptions: LockedFeatureDisplayConfig;
    children: JSX.Element;
    className?: string;
}

const FeatureLock: FC<FeatureLockProps> = ({ displayOptions, children, className }) => {
    if (displayOptions.enabled) {
        return children;
    }
    if (displayOptions.disabledDisplay === DisabledDisplayOptions.TOOLTIP) {
        return (
            <LockedFeatureTooltip tooltipProps={displayOptions.tooltipProps} className={className}>
                {children}
            </LockedFeatureTooltip>
        );
    }
    if (displayOptions.disabledDisplay === DisabledDisplayOptions.SHOWSTOPPER) {
        return (
            <LockedFeatureShowstopper showstopperProps={displayOptions.showstopperProps} className={className}>
                {children}
            </LockedFeatureShowstopper>
        );
    }
    if (displayOptions.disabledDisplay === DisabledDisplayOptions.HIDDEN) {
        return null;
    }
    console.error(
        // @ts-ignore - after all the condition TS thinks displayOption is from type 'never'
        `Used FeatureLock on a feature that has a wrong disabledDisplay option, disabledDisplay option: ${displayOptions.disabledDisplay}`
    );
    return null;
};

export default FeatureLock;
